module.exports = __webpack_public_path__ + "img/jz.10ec41fb.png";